import { Avatar, Box, Rating, Typography } from '@mui/material'
import { Constants, ImagePathNode } from '../../shared/constants'
import StarIcon from '@mui/icons-material/Star';

const ReviewRatingCom = ({ review }) => {
  const user = review?.user;
  const profileImage = user?.profile_image
    ? `${ImagePathNode}${user.profile_image}`
    : Constants.customImages.UserAvatar;

  const fullName = user
    ? `${user.firstname} ${user.lastname}`
    : 'Anonymous';

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        p: 2,
        mb: 2,
        // boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Avatar
          src={profileImage}
          alt={fullName}
          sx={{ width: 40, height: 40 }}
        />

        <Box>
          {/* Name + Rating inline */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>
              {fullName}
            </Typography>

            <Rating
              value={Number(review?.level) || 0}
              readOnly
              size="small"
              icon={<StarIcon sx={{ color: '#f44336', fontSize: 16 }} />}
              emptyIcon={<StarIcon sx={{ fontSize: 16, color: '#ddd' }} />}
            />
          </Box>

          {/* Review text */}
          <Typography
            sx={{
              fontSize: '13px',
              color: '#6b7280',
              mt: 0.5,
              lineHeight: '20px',
            }}
          >
            {review?.text}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewRatingCom;